const about = {
  proficiencies: ['React', 'Node.js', 'Ruby on Rails', 'C/C++', 'MySQL', 'Firebase', 'Android', 'Java', 'Python'],
  description: `A tech smith who loves to mold the new technologies and play around. A software engineer and a hackathon enthusiast, involved mainly in web. You can find me doing open-source contributions or organizing tech events during my free time.`
};

export default about;
